import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { ProgressSpinner } from "primereact/progressspinner";
import { confirmDialog } from 'primereact/confirmdialog';
import { Dropdown, DropdownChangeEvent, DropdownProps } from "primereact/dropdown";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getAppCurrencyType } from "../../../../../../../Utils/Common";
import { motion } from 'framer-motion';

import { Section, SubSection, SectionItem, SubSectionItem } from "./SampleCustomSOW";

import { goToTop } from "../../../../../../../Components/goToTop";
import Textarea from "../../../../../../../Components/TextArea";
import TextInput from "../../../../../../../Components/TextInput";
import DownloadSOW from "../../DownloadSOW";
import { ProjectTenderDetailInterface } from "../../../../../../../Controllers/Types/Tender/projectTenderDetailsInterface";
import { useAppDispatch, useAppSelector } from "../../../../../../../Controllers/hooks";
import { getProjectTenderDetailList, getSowPriliminaryData, getSowSectionAndPriliminary, getSowSectionData } from "../../../../../../../Controllers/Thunks/tenderThunks";
import { Priliminary, SowSection, SowSectionItemData, SowSubSection, SowSubSectionItemData } from "../../../../../../../Controllers/Types/Tender/tenderSow";
import { setSowCurrentTenderPart } from "../../../../../../../Controllers/Slices/tenderSlice";
import { addSowItem, addSowPriliminary, addSowSection, addSowSubSection, deleteSowItem, deleteSowPriliminary, deleteSowSection, deleteSowSubSection, createOrUpdateSowCoverPageDesc, updateSowItem, updateSowPriliminary, updateSowSection, updateSowSubSection } from "../../../../../../../Api/tenderApi";
import { checkText } from "../../../../../../../Utils/Validator";
import { ShowToast } from "../../../../../../../Components/ShowToast";

const CustomSOW: React.FC = () => {
    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const dispatch = useAppDispatch()
    const location = useLocation();
    const currencySymbol = getAppCurrencyType();

    const tenderPart = location.state as ProjectTenderDetailInterface


    const [dataState, setDataState] = useState<'Add' | 'Edit'>('Add');
    const [loading, setLoading] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [showSideBar, setShowSideBar] = useState<boolean>(false);
    const [showDownloadModal, setShowDownloadModal] = useState<boolean>(false);

    /* Cover page */
    const [showCoverPage, setShowCoverpage] = useState<boolean>(true);
    const [showCoverPageModal, setShowCoverPageModal] = useState<boolean>(false);

    const [coverPageBody, setCoverPageBody] = useState<string>('');
    const [coverPageBodyError, setCoverPageBodyError] = useState<string>('');

    /* Sections */
    const [sectionData, setSectionData] = useState<Section[]>([]);
    const [showSection, setShowSection] = useState<boolean>(false);
    const [toggledSection, setToggledSection] = useState<boolean>(false);
    const [hasSection, setHasSection] = useState<boolean>(false);
    const [showSectionModal, setShowSectionModal] = useState<boolean>(false);
    const [selectedSection, setSelectedSection] = useState<SowSection | null>(null);
    const [sectionsList, setSectionsList] = useState<SowSection[]>([]);
    const [selectedSectionDataAfter, setSelectedSectionDataAfter] = useState<SowSection | null>(null);
    const [sectionName, setSectionName] = useState<string>('');
    const [sectionNumber, setSectionNumber] = useState<string>('');

    const [sectionNameError, setSectionNameError] = useState<string>('');
    const [sectionNoAfterError, setSectionNoAfterError] = useState<string>('');

    /* Sub section */
    const [toggledSubSection, setToggledSubSection] = useState<boolean>(false);
    const [showSubSection, setShowSubSection] = useState<boolean>(false);
    const [currentSection, setCurrentSection] = useState<SowSection | null>(null);
    const [showSubSectionModal, setShowSubSectionModal] = useState<boolean>(false);
    const [hasSubSection, setHasSubSection] = useState<boolean>(false);
    const [selectedSubSection, setSelectedSubSection] = useState<SowSubSection | null>(null);
    const [addState, setAddState] = useState<string>('sub section');
    const [subSectionsList, setSubSectionsList] = useState<SowSubSection[]>([]);
    const [selectedSubSectionDataAfter, setSelectedSubSectionDataAfter] = useState<SowSubSection | null>(null);
    const [subSectionNumber, setSubSectionNumber] = useState<string>('');
    const [subSectionName, setSubSectionName] = useState<string>('');
    const [subSectionNameError, setSubSectionNameError] = useState<string>('');

    const [subSectionNoAfterError, setSubSectionNoAfterError] = useState<string>('');


    /* Section item */
    const [selectedSectionItem, setSelectedSectionItem] = useState<SectionItem | null>(null);
    const [hasSectionItem, setHasSectionItem] = useState<boolean>(false);
    const [sectionItemsList, setSectionItemList] = useState<SowSectionItemData[]>([]);
    const [selectedSectionItemDataAfter, setSelectedSectionItemDataAfter] = useState<SowSectionItemData | null>(null);
    const [sectionItemName, setSectionItemName] = useState<string>('');
    const [sectionItemNumber, setSectionItemNumber] = useState<string>('');

    const [sectionItemNameError, setSectionItemNameError] = useState<string>('');
    const [sectionItemNumberAfterError, setSectionItemNumberAfterError] = useState<string>('');


    /* Sub section item */
    const [currentSubSection, setCurrentSubSection] = useState<SowSubSection | null>(null);
    const [showSubSectionItem, setShowSubSectionItem] = useState<boolean>(false);
    const [hasSubSectionItem, setHasSubSectionItem] = useState<boolean>(false);
    const [selectedSubSectionItem, setSelectedSubSectionItem] = useState<SowSubSectionItemData | null>(null);
    const [showSubSectionItemModal, setShowSubSectionItemModal] = useState<boolean>(false);
    const [subSectionItemsList, setSubSectionItemsList] = useState<SowSubSectionItemData[]>([]);
    const [selectedSubSectionItemDataAfter, setSelectedSubSectionItemDataAfter] = useState<SowSubSectionItemData | null>(null);
    const [subSectionItemName, setSubSectionItemName] = useState<string>('');
    const [subSectionItemNumber, setSubSectionItemNumber] = useState<string>('');

    const [subSectionItemNameError, setSubSectionItemNameError] = useState<string>('');
    const [subSectionItemNumberAfterError, setSubSectionItemNumberAfterError] = useState<string>('');


    /* Preliminaries */
    const [showPreliminaries, setShowPreliminaries] = useState<boolean>(false);
    const [preliminariesList, setPreliminariesList] = useState<Priliminary[]>([]);
    const [selectedPreliminary, setSelectedPreliminary] = useState<Priliminary | null>(null);
    const [selectedPreliminaryDataAfter, setSelectedPreliminaryDataAfter] = useState<Priliminary | null>(null);
    const [hasPreliminary, setHasPreliminary] = useState<boolean>(false);
    const [showPreliminaryModal, setShowPreliminaryModal] = useState<boolean>(false);
    const [preliminaryItemNumber, setPreliminaryItemNumber] = useState<string>('');
    const [preliminaryItemName, setPreliminaryItemName] = useState<string>('');

    const [preliminaryItemNameError, setPreliminaryItemNameError] = useState<string>('');
    const [preliminaryItemNumberAfterError, setPreliminaryItemNumberAfterError] = useState<string>('');


    /* For search */
    const [showSearchModal, setShowSearchModal] = useState<boolean>(false);
    const [searchKey, setSearchKey] = useState<string>('');
    const [filteredSectionItemData, setFilteredSectionItemData] = useState<SectionItem[]>([]);
    const [filteredSubSectionItemData, setFilteredSubSectionItemData] = useState<SowSubSectionItemData[]>([]);

    const { loadingViewSowSectionAndPriliminary, viewSowSection, viewSowPriliminary, currentProjectTenderDetail, loadingViewSowSection, loadingViewSowPriliminary } = useAppSelector((state) => state.tender);


    useEffect(() => {
        dispatch(getSowSectionAndPriliminary(tenderPart.project_tender_part_id));
        dispatch(setSowCurrentTenderPart(tenderPart));
        handleShowCoverPage();
    }, []);



    useEffect(() => {
        const updatedSectionsList: SowSection[] = [
            { section_no: '0', section_id: 0, section_name: "At the beginning", section_item_data: [], sub_section_data: [], after_section_no: 0 },
            ...viewSowSection,
        ];

        setSectionsList(updatedSectionsList);

        const checkSectionHasData = () => {
            if (viewSowSection.length > 0) {
                setHasSection(true);

            } else {
                setHasSection(false);
            }
        };

        const resetCurrentSection = () => {
            if (currentSection) {
                const secList = viewSowSection.filter((sec) => sec.section_id === currentSection.section_id)

                if (secList.length > 0) {
                    setCurrentSection((prev) => {
                        if (!prev) return null;
                        return { ...prev, sub_section_data: secList[0].sub_section_data, section_item_data: secList[0].section_item_data, };
                    });

                    const updatedSubSectionsList: SowSubSection[] = [
                        { sub_section_id: 0, section_id: 0, sub_section_name: "At the beginning", sub_section_no: "0", sub_section_item_data: [], after_sub_section_no: 0 },
                        ...secList[0].sub_section_data,
                    ];

                    setSubSectionsList(updatedSubSectionsList);

                    const updatedSectionItemsList: SowSectionItemData[] = [
                        { item_id: 0, section_id: 0, item_name: "At the beginning", item_no: "0", after_item_no: 0 },
                        ...secList[0].section_item_data!,
                    ];

                    setSectionItemList(updatedSectionItemsList);

                    //================================= currentSubSection ========================================
                    if (currentSubSection) {
                        const secList = viewSowSection.filter((sec) => sec.section_id === currentSection.section_id)
                        if (secList.length > 0) {
                            const subSecList = secList[0].sub_section_data.filter((subSection) => subSection.sub_section_id === currentSubSection.sub_section_id)

                            if (subSecList.length > 0) {
                                setCurrentSubSection((prev) => {
                                    if (!prev) return null;
                                    return { ...prev, sub_section_item_data: subSecList[0].sub_section_item_data };
                                });

                                const updatedSubSectionItemsList: SowSubSectionItemData[] = [
                                    { item_id: 0, sub_section_id: 0, item_name: "At the beginning", item_no: "0", after_item_no: 0 },
                                    ...subSecList[0].sub_section_item_data!,
                                ];

                                setSubSectionItemsList(updatedSubSectionItemsList);
                            }
                        }

                    }


                }

            } else {
                setCurrentSection(null);
            }


        };



        checkSectionHasData();
        resetCurrentSection();

    }, [viewSowSection]);

    useEffect(() => {
        const updatedPriliminaryList: Priliminary[] = [
            { priliminiery_id: 0, project_tender_part_id: 0, item_name: "At the beginning", ref_number: '0', after_ref_number: 0 },
            ...viewSowPriliminary,
        ];

        setPreliminariesList(updatedPriliminaryList)
    }, [viewSowPriliminary])

    /* ************************* handleSetSectionNumber(); *****************************/
    useEffect(() => {
        if (dataState === 'Add') {
            handleSetSectionNumber();
        }

    }, [selectedSectionDataAfter]);

    /* ************************* handleSetSubSectionNumber(); *****************************/
    useEffect(() => {
        if (dataState === 'Add') {
            handleSetSubSectionNumber();
        }

    }, [selectedSubSectionDataAfter]);


    /* ************************* handleSetSubSectionNumber(); *****************************/
    useEffect(() => {
        if (dataState === 'Add') {
            handleSetSectionItemNumber();
        }

    }, [selectedSectionItemDataAfter]);


    /* ************************* handleSetSubSectionNumber(); *****************************/
    useEffect(() => {
        if (dataState === 'Add') {
            handleSetSubSectionItemNumber();
        }

    }, [selectedSubSectionItemDataAfter]);


    /* ************************* handleSetSubSectionNumber(); *****************************/
    useEffect(() => {
        if (dataState === 'Add') {
            handleSetPreliminaryItemNumber();
        }

    }, [selectedPreliminaryDataAfter]);


    /* ********************************* Section item ********************************* */
    useEffect(() => {
        if (hasSectionItem && currentSection?.section_item_data) {
            const filtered = currentSection.section_item_data.filter((item) => {
                const searchLower = searchKey.toLowerCase();
                return (
                    item.item_name.toLowerCase().includes(searchLower) ||
                    item.item_no.toLowerCase().includes(searchLower)
                );
            });
            setFilteredSectionItemData(filtered);
        }
    }, [searchKey, hasSectionItem, currentSection?.section_item_data]);

    /* ******************************* Sub Section item ******************************* */
    useEffect(() => {
        if (hasSubSectionItem && currentSubSection?.sub_section_item_data) {
            const filtered = currentSubSection.sub_section_item_data.filter((item) => {
                const searchLower = searchKey.toLowerCase();
                return (
                    item.item_name.toLowerCase().includes(searchLower) ||
                    item.item_no.toLowerCase().includes(searchLower)
                );
            });
            setFilteredSubSectionItemData(filtered);
        }
    }, [searchKey, hasSubSectionItem, currentSubSection?.sub_section_item_data]);




    /* ******************************** Cover page ******************************** */
    const handleShowCoverPage = () => {
        setShowCoverpage(true);

        setShowSection(false);
        setShowSubSection(false);
        setShowPreliminaries(false);
        setShowSubSectionItem(false);

        setToggledSection(false);
        setToggledSubSection(false);
    }

    const handleAddCoverPage = () => {
        setDataState('Add');
        setShowCoverPageModal(true);
    }

    const handleCreateCoverPage = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (checkCredentialsCoverPage()) {
                setLoading(true);
                const res = await createOrUpdateSowCoverPageDesc(currentProjectTenderDetail?.project_tender_part_id!, coverPageBody);
                setLoading(false);

                if (res.status) {
                    dispatch(getProjectTenderDetailList(currentProjectTenderDetail?.folder_id!));
                    handleCloseCoverPageModal();
                    ShowToast(toast, 'success', 'Success', 'Cover page updated successfully.');
                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error updating cover page.');
                }
            }
        } catch (error) {
            setLoading(false);
            ShowToast(toast, 'error', 'Failed', 'There was an error creating cover page.');
        }
    }

    const handleEditCoverPage = () => {
        setDataState('Edit');
        setShowCoverPageModal(true);
        setCoverPageBody(currentProjectTenderDetail?.coverPageDesc!);
    }

    const handleUpdateCoverPage = async (e: React.FormEvent) => {
        e.preventDefault();


        if (checkCredentialsCoverPage()) {


            try {

                setLoading(true);
                const res = await createOrUpdateSowCoverPageDesc(currentProjectTenderDetail?.project_tender_part_id!, coverPageBody);
                setLoading(false);

                if (res.status) {
                    dispatch(getProjectTenderDetailList(currentProjectTenderDetail?.folder_id!));
                    handleCloseCoverPageModal();
                    ShowToast(toast, 'success', 'Success', 'Cover page updated successfully.');

                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error updating cover page.');

                }


            } catch (error) {
                ShowToast(toast, 'error', 'Failed', 'There was an error updating cover page.');

            }
        }


    }

    function checkCredentialsCoverPage(): boolean {
        const isCoverPageBody = checkText(coverPageBody, true, setCoverPageBodyError);

        return isCoverPageBody;
    }

    const handleDeleteCoverPage = (): void => {
        confirmDialog({
            message: 'Are you sure you want to delete the cover page?',
            header: 'Confirm the deletion',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteCoverPage(),
        });
    }

    const deleteCoverPage = async () => {
        try {
            setTimeout(() => {

            }, 500);
        } catch (err) {
            ShowToast(toast, 'error', 'Failed', 'Error deleting cover page.');

        }
    }

    const handleCloseCoverPageModal = () => {
        setShowCoverPageModal(false);
    }

    /* Modal header */
    const coverPageModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState} cover page
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseCoverPageModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const coverPageModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Cancel" className="custom_btn secondary" onClick={handleCloseCoverPageModal} />
            <Button label={`${loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}`}
                onClick={dataState === 'Add' ? handleCreateCoverPage : handleUpdateCoverPage}
                loading={loading} className="custom_btn primary" />
        </div>
    );
    /* **************************************************************************** */




    const handleSetSectionAfter = () => {

        if (viewSowSection.length === 0) {
            setSelectedSectionDataAfter(sectionsList[0])

        } else {
            const largestSection = viewSowSection.reduce((largest, section) => {
                return Number(section.section_no) > Number(largest.section_no) ? section : largest;
            }, viewSowSection[0])

            if (largestSection !== null) {
                setSelectedSectionDataAfter(largestSection)
            }
        }



    };

    const handleShowSections = () => {
        setShowSection(true);
        setToggledSection(!toggledSection);
        setShowCoverpage(false);
        setShowSubSection(false);
        setShowPreliminaries(false);
        setShowSubSectionItem(false);
    }

    const handleAddSection = () => {
        setDataState('Add');
        setShowSectionModal(true);
        setSelectedSection(null);
        setSectionName('');
        handleSetSectionAfter();

    }

    const handleCreateSection = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            if (checkCredentialsSection()) {
                setLoading(true);
                const res = await addSowSection(currentProjectTenderDetail?.project_tender_part_id!, sectionName, Number(selectedSectionDataAfter?.section_no))
                setLoading(false);

                if (res.status) {
                    handleCloseSectionModal();
                    setHasSection(true);

                    dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))
                    ShowToast(toast, 'success', 'Success', 'Section created successfully.');


                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error creating section.');

                }
            }



        } catch (error) {
            ShowToast(toast, 'error', 'Failed', 'There was an error creating section.');

        }
    }

    const handleEditSection = () => {
        setDataState('Edit');
        setShowSectionModal(true);

        if (selectedSection) {
            setSectionName(selectedSection?.section_name!);
            setSectionNumber(`${selectedSection?.section_no}`)

            const afterSection = viewSowSection.filter((section) => section.after_section_no === selectedSection.after_section_no)

            if (afterSection !== null) {
                if (afterSection[0].after_section_no === 0) {
                    setSelectedSectionDataAfter(sectionsList[0])
                } else {
                    setSelectedSectionDataAfter(sectionsList[afterSection[0].after_section_no! - 1])
                }

            }
        } else {
            setSectionName('');
            setSectionNumber('');
        }
    }

    const handleUpdateSection = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            if (checkCredentialsUpdateSection()) {

                setLoading(true);
                const res = await updateSowSection(currentProjectTenderDetail?.project_tender_part_id!, selectedSection?.section_id!, sectionName, selectedSectionDataAfter?.after_section_no!)
                setLoading(false);

                if (res.status) {
                    handleCloseSectionModal();
                    dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))
                    ShowToast(toast, 'success', 'Success', 'Section updated successfully.');


                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error updating section.');

                }
            }

        } catch (error) {
            ShowToast(toast, 'error', 'Failed', 'There was an error updating section.');

        }
    }

    const handleDeleteSection = (): void => {
        confirmDialog({
            message: `Are you sure you want to delete the section ${selectedSection?.section_no}?`,
            header: 'Confirm the deletion',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteSection(),
        });
    }

    const deleteSection = async () => {
        try {
            const res = await deleteSowSection(selectedSection?.section_id!)

            if (res.status) {
                setSelectedSection(null);
                dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))
                ShowToast(toast, 'success', 'Success', 'Section deleted successfully.');
            } else {
                ShowToast(toast, 'error', 'Failed', 'Error deleting section.');
            }
        } catch (err) {
            ShowToast(toast, 'error', 'Failed', 'Error deleting section.');
        }
    }

    function checkCredentialsSection(): boolean {
        const is_sectionName = checkText(sectionName, true, setSectionNameError);

        if (selectedSectionDataAfter === null || selectedSectionDataAfter === undefined) {
            setSectionNoAfterError('This field is required.')
        } else {
            setSectionNoAfterError('')
        }

        const isAlreadyExistsSectionName: boolean = viewSowSection.some((section) => section.section_name === sectionName);
        let isAllowSectionName: boolean = true;
        if (isAlreadyExistsSectionName) {
            isAllowSectionName = false;
            setSectionNameError('This section already added');
        }


        return is_sectionName && isAllowSectionName && selectedSectionDataAfter !== null;
    }

    function checkCredentialsUpdateSection(): boolean {
        const is_sectionName = checkText(sectionName, true, setSectionNameError);

        if (selectedSectionDataAfter === null) {
            setSectionNoAfterError('This field is required.')
        } else {
            setSectionNoAfterError('')
        }

        const isAlreadyExistsSectionName: boolean = viewSowSection.some((section) => section.section_name === sectionName && section.section_id !== selectedSection?.section_id);
        let isAllowSectionName: boolean = true;
        if (isAlreadyExistsSectionName) {
            isAllowSectionName = false;
            setSectionNameError('This section already added');
        }

        return is_sectionName && isAllowSectionName && selectedSectionDataAfter !== null;
    }

    const handleCloseSectionModal = () => {
        setShowSectionModal(false);
        setSectionNameError('')
        setSectionNoAfterError('')

    }

    /* Modal header */
    const sectionModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState} section {dataState === 'Edit' && selectedSection?.section_no}
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseSectionModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const sectionModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Cancel" className="custom_btn secondary" onClick={handleCloseSectionModal} />
            <Button label={`${loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}`}
                onClick={dataState === 'Add' ? handleCreateSection : handleUpdateSection}
                loading={loading} className="custom_btn primary" />
        </div>
    );

    const handleSectionChange = (e: DropdownChangeEvent) => {
        const selectedData = e.value as SowSection;
        setSelectedSectionDataAfter(selectedData);

    };


    const handleSetSectionNumber = () => {
        if (viewSowSection.length === 0) {
            setSectionNumber(`1`);
        } else {
            if (selectedSectionDataAfter) {
                const lastSectionNo = selectedSectionDataAfter!.after_section_no! + 1;
                const sectionString = `${lastSectionNo}`;
                setSectionNumber(sectionString);
            }



        }
    };

    const sectionOptionsTemplate = (section: Section) => {
        return (
            <div className="d-flex align-items-center w-100 justify-content-between">
                {section.section_no !== '0' ? <div>{section.section_no} - {section.section_name}</div> : <div>{section.section_name}</div>}
            </div>
        );
    };

    const sectionValueTemplate = (value: Section, props: DropdownProps) => {
        if (value) {
            return (
                <div className="d-flex gap-3 align-items-center">
                    {value.section_no !== '0' ? <div>{value.section_no + ' - ' + value?.section_name}</div> : <div>{value?.section_name}</div>}
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };
    /* ******************************************************************************** */


    /* ********************************** Sub Section ********************************* */
    const handleShowSubSection = async (section: SowSection) => {
        setCurrentSection(section);

        if (section?.sub_section_data?.length !== 0) {
            setHasSubSection(true);

            setToggledSubSection(!toggledSubSection);
        } else {
            setHasSubSection(false);
            setToggledSubSection(false);
        }

        setShowSubSection(true);

        if (section?.section_item_data?.length !== 0) {
            setHasSectionItem(true);

        } else {
            setHasSectionItem(false);
        }

        const updatedSubSectionsList: SowSubSection[] = [
            { sub_section_id: 0, section_id: 0, sub_section_name: "At the beginning", sub_section_no: "0", sub_section_item_data: [], after_sub_section_no: 0 },
            ...section.sub_section_data,
        ];

        setSubSectionsList(updatedSubSectionsList);

        const updatedSectionItemsList: SowSectionItemData[] = [
            { item_id: 0, section_id: 0, item_name: "At the beginning", item_no: "0", after_item_no: 0 },
            ...section?.section_item_data!,
        ];

        setSectionItemList(updatedSectionItemsList);


        setShowSection(false);
        setShowCoverpage(false);
        setShowPreliminaries(false);
        setShowSubSectionItem(false);
        setToggledSection(true);
        setSearchKey('');
    }

    const handleSetSubSectionNumber = () => {
        if (currentSection && currentSection.sub_section_data) {
            const currentSectionNumber = currentSection.section_no;

            if (currentSection.sub_section_data.length === 0) {
                setSubSectionNumber(`${currentSectionNumber}.01`);
            } else {
                const lastSubSectionNo = selectedSubSectionDataAfter!.after_sub_section_no! + 1;
                const subSectionString = `${currentSectionNumber}.${lastSubSectionNo}`;
                setSubSectionNumber(formatNumberWithMultipleDecimals(subSectionString));
            }
        }
    };

    const formatNumberWithMultipleDecimals = (input: string): string => {
        // Split the input by the decimal points
        const parts = input.split('.');

        // Format each part: keep the integer part as-is, but pad fractional parts to 2 digits
        const formattedParts = parts.map((part, index) =>
            index === 0 ? part : part.padStart(2, '0') // First part (integer) stays unchanged; others are padded
        );

        // Join the parts back together with a dot
        return formattedParts.join('.');
    };

    const handleSetSectionItemNumber = () => {
        if (currentSection && currentSection.section_item_data) {
            const currentSectionNumber = currentSection.section_no;

            if (currentSection.section_item_data.length === 0) {
                setSectionItemNumber(`${currentSectionNumber}.01`);
            } else {


                const lastSubSectionNo = selectedSectionItemDataAfter!.after_item_no! + 1;
                const subSectionString = `${currentSectionNumber}.${lastSubSectionNo}`;
                setSectionItemNumber(formatNumberWithMultipleDecimals(subSectionString));

            }
        }
    };

    const handleSetSubSectionDataAfter = () => {

        if (currentSection) {

            if (currentSection.sub_section_data.length === 0) {
                setSelectedSubSectionDataAfter(subSectionsList[0]);
            } else {
                const largestSubSection = currentSection.sub_section_data.reduce((largest, subSection) => {
                    return Number(subSection.after_sub_section_no) > Number(largest.after_sub_section_no) ? subSection : largest;
                }, currentSection.sub_section_data[0])

                if (largestSubSection !== null) {
                    setSelectedSubSectionDataAfter(largestSubSection)
                }

            }
        }

    }

    const handleSetSectionItemDatAfter = () => {

        if (currentSection?.section_item_data?.length !== 0) {
            setHasSectionItem(true);


            const largestSection = currentSection?.section_item_data.reduce((largest, section) => {
                return Number(section.after_item_no) > Number(largest.after_item_no) ? section : largest;
            }, currentSection?.section_item_data[0])

            if (largestSection !== null) {
                setSelectedSectionItemDataAfter(largestSection!)
            }



        } else {
            setSelectedSectionItemDataAfter(sectionItemsList[0])
            setHasSectionItem(false);
        }

    }



    const handleAddSubSection = () => {
        setDataState('Add');
        setShowSubSectionModal(true);

        handleSetSubSectionDataAfter();


        //Section item data
        handleSetSectionItemDatAfter();


        if (hasSectionItem) {
            setAddState('item');
        } else if (hasSubSection) {
            setAddState('sub section');
        } else {
            setAddState('sub section');
        }

        setSelectedSubSection(null);
        setSubSectionName('');

        setSelectedSectionItem(null);
        setSectionItemName('');
    }

    const handleCreateSubSection = async (e: React.FormEvent) => {
        e.preventDefault();


        try {

            if (checkCredentialsSubSection()) {
                setLoading(true);
                const res = await addSowSubSection(currentSection?.section_id!, subSectionName, selectedSubSectionDataAfter?.after_sub_section_no!)
                setLoading(false);

                if (res.status) {
                    dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))

                    handleCloseSubSectionModal();
                    setHasSubSection(true);
                    ShowToast(toast, 'success', 'Success', 'Sub section created successfully.');

                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error creating sub section.');

                }
            }



        } catch (error) {
            ShowToast(toast, 'error', 'Failed', 'There was an error creating sub section.');

        }
    }

    const handleEditSubSection = () => {
        setDataState('Edit');
        setShowSubSectionModal(true);

        if (selectedSubSection) {
            setSubSectionName(selectedSubSection?.sub_section_name!);
            setSubSectionNumber(`${selectedSubSection?.sub_section_no}`)
            setAddState('sub section');

            const afterSubSection = subSectionsList.filter((section) => section.after_sub_section_no === selectedSubSection.after_sub_section_no)

            if (afterSubSection!.length > 0) {
                if (afterSubSection![0].after_sub_section_no === 0) {
                    setSelectedSubSectionDataAfter(subSectionsList[0])
                } else {
                    setSelectedSubSectionDataAfter(subSectionsList[afterSubSection![0].after_sub_section_no! - 1])
                }

            }

        } else {
            setSubSectionName('');
        }
    }

    const handleUpdateSubSection = async (e: React.FormEvent) => {
        e.preventDefault();


        try {

            if (checkCredentialsSubSectionUpdate()) {
                setLoading(true);
                const res = await updateSowSubSection(selectedSubSection?.sub_section_id!, currentSection?.section_id!, subSectionName, selectedSubSectionDataAfter?.after_sub_section_no!)
                setLoading(false);

                if (res.status) {
                    handleCloseSubSectionModal();
                    dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))
                    ShowToast(toast, 'success', 'Success', 'Sub section updated successfully.');


                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error updating sub section.');

                }
            }



        } catch (error) {
            ShowToast(toast, 'error', 'Failed', 'There was an error updating sub section.');

        }
    }

    const handleDeleteSubSection = (): void => {
        confirmDialog({
            message: `Are you sure you want to delete the sub section ${selectedSubSection?.sub_section_no}?`,
            header: 'Confirm the deletion',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteSubSection(),
        });
    }

    const deleteSubSection = async () => {
        try {

            const res = await deleteSowSubSection(selectedSubSection?.sub_section_id!)

            if (res.status) {
                setSelectedSubSection(null);

                dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))

                ShowToast(toast, 'success', 'Success', 'Sub section deleted successfully.');

            } else {
                ShowToast(toast, 'error', 'Failed', 'Error deleting sub section.');

            }


        } catch (err) {
            ShowToast(toast, 'error', 'Failed', 'Error deleting sub section.');

        }
    }

    function checkCredentialsSubSection(): boolean {
        const is_subSectionName = checkText(subSectionName, true, setSubSectionNameError);

        if (selectedSubSectionDataAfter === null || selectedSubSectionDataAfter === undefined) {
            setSubSectionNoAfterError('This field is required.')
        } else {
            setSubSectionNoAfterError('')
        }

        const isAlreadyExistsSectionName = currentSection?.sub_section_data.some((section) => section.sub_section_name === subSectionName);
        let isAllowSubSectionName: boolean = true;
        if (isAlreadyExistsSectionName) {
            isAllowSubSectionName = false;
            setSubSectionNameError('This sub section already added');
        }

        return is_subSectionName && isAllowSubSectionName && selectedSubSectionDataAfter !== null;
    }

    function checkCredentialsSubSectionUpdate(): boolean {
        const is_subSectionName = checkText(subSectionName, true, setSubSectionNameError);

        if (selectedSubSectionDataAfter === null) {
            setSubSectionNoAfterError('This field is required.')
        } else {
            setSubSectionNoAfterError('')
        }

        const isAlreadyExistsSectionName = currentSection?.sub_section_data.some((section) => section.sub_section_name === subSectionName && section.sub_section_id !== selectedSubSection?.sub_section_id);
        let isAllowSubSectionName: boolean = true;
        if (isAlreadyExistsSectionName) {
            isAllowSubSectionName = false;
            setSubSectionNameError('This sub section already added');
        }

        return is_subSectionName && isAllowSubSectionName && selectedSubSectionDataAfter !== null;
    }



    const handleCloseSubSectionModal = () => {
        setShowSubSectionModal(false);
        setSubSectionNameError('')
        setSubSectionNoAfterError('')

        setSectionItemNameError('')
        setSectionItemNumberAfterError('')

    }

    const handleSubSectionChange = (e: DropdownChangeEvent) => {
        const selectedData = e.value as SowSubSection;
        setSelectedSubSectionDataAfter(selectedData);
    };

    const subSectionOptionsTemplate = (subSection: SubSection) => {
        return (
            <div className="d-flex align-items-center w-100 justify-content-between">
                {subSection.sub_section_no! !== '0' ? <div className="data_max_length">{subSection.sub_section_no} - {subSection.sub_section_name}</div> :
                    <div className="data_max_length">{subSection.sub_section_name}</div>}
            </div>
        );
    };

    const subSectionValueTemplate = (value: SubSection, props: DropdownProps) => {
        if (value) {
            return (
                <div className="d-flex gap-3 align-items-center">
                    {value?.sub_section_no !== '0' ? <div>{value?.sub_section_no + ' - ' + value?.sub_section_name}</div> : <div>{value?.sub_section_name}</div>}
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };


    const handleCreateItem = async (e: React.FormEvent) => {
        e.preventDefault();


        try {
            if (checkCredentialsSectionItem()) {
                setLoading(true);
                const res = await addSowItem('Section', currentSection?.section_id!, 0, sectionItemName, selectedSectionItemDataAfter?.after_item_no!)
                setLoading(false);

                if (res.status) {
                    dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))
                    handleCloseSubSectionModal();
                    setHasSectionItem(true);

                    ShowToast(toast, 'success', 'Success', 'Item added successully');

                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error creating item.');
                }
            }



        } catch (error) {
            ShowToast(toast, 'error', 'Failed', 'There was an error creating item.');

        }
    }

    const handleEditItem = () => {
        setDataState('Edit');
        setShowSubSectionModal(true);

        if (selectedSectionItem) {
            setSectionItemName(selectedSectionItem?.item_name!);
            setAddState('item');
            setSectionItemNumber(`${selectedSectionItem?.item_no}`)

            const afterSubSection = sectionItemsList.filter((section) => section.after_item_no === selectedSectionItem.after_item_no)

            if (afterSubSection!.length > 0) {
                if (afterSubSection![0].after_item_no === 0) {
                    setSelectedSectionItemDataAfter(sectionItemsList[0])
                } else {
                    setSelectedSectionItemDataAfter(sectionItemsList[afterSubSection![0].after_item_no! - 1])
                }

            }

        } else {
            setSectionItemName('');
        }
    }

    const handleUpdateItem = async (e: React.FormEvent) => {
        e.preventDefault();


        try {
            if (checkCredentialsSectionItemUpdate()) {
                setLoading(true);
                const res = await updateSowItem(selectedSectionItem?.item_id!, 'Section', currentSection?.section_id!, 0, sectionItemName, selectedSectionItemDataAfter?.after_item_no!)
                setLoading(false);

                if (res.status) {
                    dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))
                    handleCloseSubSectionModal();
                    ShowToast(toast, 'success', 'Success', 'Item updated successfully.');
                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error updating item.');
                }
            }



        } catch (error) {
            ShowToast(toast, 'error', 'Failed', 'There was an error updating item.');
        }
    }

    const handleDeleteItem = (): void => {
        confirmDialog({
            message: `Are you sure you want to delete the item ${selectedSectionItem?.item_no}?`,
            header: 'Confirm the deletion',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteItem(),
        });
    }

    const deleteItem = async () => {
        try {

            const res = await deleteSowItem(selectedSectionItem?.item_id!);
            if (res.status) {
                dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))
                ShowToast(toast, 'success', 'Success', 'Item deleted successfully.');
            } else {
                ShowToast(toast, 'error', 'Failed', 'Error deleting item.');
            }


        } catch (err) {
            ShowToast(toast, 'error', 'Failed', 'Error deleting item.');

        }
    }

    function checkCredentialsSectionItem(): boolean {
        const is_subSectionName = checkText(sectionItemName, true, setSectionItemNameError);

        if (selectedSectionItemDataAfter === null || selectedSectionItemDataAfter === undefined) {
            setSectionItemNumberAfterError('This field is required.')
        } else {
            setSectionItemNumberAfterError('')
        }

        const isAlreadyExistsSectionName = currentSection?.section_item_data.some((section) => section.item_name === sectionItemName);
        let isAllowSubSectionName: boolean = true;
        if (isAlreadyExistsSectionName) {
            isAllowSubSectionName = false;
            setSectionItemNameError('This section item already added');
        }

        return is_subSectionName && isAllowSubSectionName && selectedSectionItemDataAfter !== null;
    }

    function checkCredentialsSectionItemUpdate(): boolean {
        const is_subSectionName = checkText(sectionItemName, true, setSectionItemNameError);

        if (selectedSectionItemDataAfter === null) {
            setSectionItemNumberAfterError('This field is required.')
        } else {
            setSectionItemNumberAfterError('')
        }

        const isAlreadyExistsSectionName = currentSection?.section_item_data.some((section) => section.item_name === sectionItemName && section.item_id !== selectedSectionItem?.item_id);
        let isAllowSubSectionName: boolean = true;
        if (isAlreadyExistsSectionName) {
            isAllowSubSectionName = false;
            setSectionItemNameError('This section item already added');
        }

        return is_subSectionName && isAllowSubSectionName && selectedSectionItemDataAfter !== null;
    }


    const handleSectionItemChange = (e: DropdownChangeEvent) => {
        const selectedData = e.value as SowSectionItemData;
        setSelectedSectionItemDataAfter(selectedData);
    };

    const sectionItemOptionsTemplate = (sectionItem: SectionItem) => {
        return (
            <div className="d-flex align-items-center w-100 justify-content-between">
                {sectionItem.item_no !== '0' ? <div className="data_max_length">{sectionItem.item_no} - {sectionItem.item_name}</div> : <div className="data_max_length">{sectionItem.item_name}</div>}
            </div>
        );
    };

    const sectionItemValueTemplate = (value: SectionItem, props: DropdownProps) => {
        if (value) {
            return (
                <div className="d-flex gap-3 align-items-center">
                    {value.item_no !== '0' ? <div>{value?.item_no + ' - ' + value?.item_name}</div> : <div>{value?.item_name}</div>}
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    /* Modal header */
    const subSectionModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState} {addState} {dataState === 'Edit' && selectedSubSection?.sub_section_no}
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseSubSectionModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const subSectionModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Cancel" className="custom_btn secondary" onClick={handleCloseSubSectionModal} />

            {addState === 'sub section' ? (
                <Button label={`${loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}`}
                    onClick={dataState === 'Add' ? handleCreateSubSection : handleUpdateSubSection}
                    loading={loading} className="custom_btn primary" />
            ) : (
                <Button label={`${loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}`}
                    onClick={dataState === 'Add' ? handleCreateItem : handleUpdateItem}
                    loading={loading} className="custom_btn primary" />
            )}
        </div>
    );


    const handleShowSubSectionItem = async (subSection: SowSubSection) => {
        setCurrentSubSection(subSection)

        const updatedSubSectionItemsList: SowSubSectionItemData[] = [
            { item_id: 0, sub_section_id: 0, item_name: "At the beginning", item_no: "0", after_item_no: 0 },
            ...subSection?.sub_section_item_data!,
        ];
        setSubSectionItemsList(updatedSubSectionItemsList);


        if (subSection?.sub_section_item_data?.length !== 0) {
            setHasSubSectionItem(true);

            setSelectedSubSectionItemDataAfter(updatedSubSectionItemsList[0]);

        } else {

            setSelectedSubSectionItemDataAfter(updatedSubSectionItemsList[0]);

            setHasSubSectionItem(false);
        }

        setShowSubSectionItem(true);
        setShowSection(false);
        setShowCoverpage(false);
        setShowPreliminaries(false);
        setShowSubSection(false);

        setSearchKey('');
    }

    const handleSetSubSectionItemNumber = () => {
        if (currentSubSection && currentSubSection.sub_section_item_data) {
            const currentSectionNumber = currentSubSection.sub_section_no;

            if (currentSubSection.sub_section_item_data.length === 0) {
                setSubSectionItemNumber(`${currentSectionNumber}.01`);
            } else {
                const lastSubSectionNo = selectedSubSectionItemDataAfter!.after_item_no! + 1;
                const subSectionString = `${currentSectionNumber}.${lastSubSectionNo}`;
                setSubSectionItemNumber(formatNumberWithMultipleDecimals(subSectionString));
            }
        }
    };

    const handleAddSubSectionItem = () => {
        setDataState('Add');
        setShowSubSectionItemModal(true);

        handleSetSubSectionItemDataAfter();

        setSelectedSubSectionItem(null);
        setSubSectionItemName('');
    }

    const handleCreateSubSectionItem = async (e: React.FormEvent) => {
        e.preventDefault();


        try {
            if (checkCredentialsSubSectionItem()) {
                setLoading(true);
                const res = await addSowItem('Sub Section', currentSection?.section_id!, currentSubSection?.sub_section_id!, subSectionItemName, selectedSubSectionItemDataAfter?.after_item_no!)
                setLoading(false);

                if (res.status) {
                    dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))
                    handleCloseSubSectionItemModal();
                    setHasSubSectionItem(true);

                    ShowToast(toast, 'success', 'Success', 'Sub section item added successully');

                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error creating sub section item.');
                }
            }


        } catch (error) {

            ShowToast(toast, 'error', 'Failed', 'There was an error creating sub section item.');

        }
    }

    const handleEditSubSectionItem = () => {
        setDataState('Edit');
        setShowSubSectionItemModal(true);

        if (selectedSubSectionItem) {
            setSubSectionItemName(selectedSubSectionItem?.item_name!);
            setSubSectionItemNumber(`${selectedSubSectionItem?.item_no}`)

            const afterSubSection = subSectionItemsList.filter((section) => section.after_item_no === selectedSubSectionItem.after_item_no)

            if (afterSubSection!.length > 0) {
                if (afterSubSection![0].after_item_no === 0) {
                    setSelectedSubSectionItemDataAfter(subSectionItemsList[0])
                } else {
                    setSelectedSubSectionItemDataAfter(subSectionItemsList[afterSubSection![0].after_item_no! - 1])
                }

            }

        } else {
            setSubSectionName('');
        }
    }

    const handleUpdateSubSectionItem = async (e: React.FormEvent) => {
        e.preventDefault();

        try {

            if (checkCredentialsSubSectionItemUpdate()) {
                setLoading(true);
                const res = await updateSowItem(selectedSubSectionItem?.item_id!, 'Sub Section', currentSubSection?.section_id!, currentSubSection?.sub_section_id!, subSectionItemName, selectedSubSectionItemDataAfter?.after_item_no!)
                setLoading(false);

                if (res.status) {
                    dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))
                    handleCloseSubSectionItemModal();
                    ShowToast(toast, 'success', 'Success', 'Sub section item updated successfully.');
                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error updating sub section item.');
                }
            }


        } catch (error) {

            ShowToast(toast, 'error', 'Failed', 'There was an error updating sub section item.');

        }
    }

    const handleDeleteSubSectionItem = (): void => {
        confirmDialog({
            message: `Are you sure you want to delete the sub section item ${selectedSubSectionItem?.item_no}?`,
            header: 'Confirm the deletion',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteSubSectionItem(),
        });
    }

    const deleteSubSectionItem = async () => {
        try {

            const res = await deleteSowItem(selectedSubSectionItem?.item_id!);
            if (res.status) {
                dispatch(getSowSectionData(currentProjectTenderDetail?.project_tender_part_id!))
                ShowToast(toast, 'success', 'Success', 'Sub section item deleted successfully.');
            } else {
                ShowToast(toast, 'error', 'Failed', 'Error deleting sub section item.');
            }

        } catch (err) {
            ShowToast(toast, 'error', 'Failed', 'Error deleting sub section item.');

        }
    }

    const handleSetSubSectionItemDataAfter = () => {

        if (currentSubSection?.sub_section_item_data?.length !== 0) {
            setHasSubSectionItem(true);


            const largestSection = currentSubSection?.sub_section_item_data.reduce((largest, section) => {
                return Number(section.after_item_no) > Number(largest.after_item_no) ? section : largest;
            }, currentSubSection?.sub_section_item_data[0])

            if (largestSection !== null) {
                setSelectedSubSectionItemDataAfter(largestSection!)
            }



        } else {
            setSelectedSubSectionItemDataAfter(subSectionItemsList[0])
            setHasSubSectionItem(false);
        }

    }

    function checkCredentialsSubSectionItem(): boolean {
        const is_subSectionName = checkText(subSectionItemName, true, setSubSectionItemNameError);

        if (selectedSubSectionItemDataAfter === null || selectedSubSectionItemDataAfter === undefined) {
            setSubSectionItemNumberAfterError('This field is required.')
        } else {
            setSubSectionItemNumberAfterError('')
        }

        const isAlreadyExistsSectionName = currentSubSection?.sub_section_item_data.some((section) => section.item_name === subSectionItemName);
        let isAllowSubSectionName: boolean = true;
        if (isAlreadyExistsSectionName) {
            isAllowSubSectionName = false;
            setSubSectionItemNameError('This sub section item already added');
        }

        return is_subSectionName && isAllowSubSectionName && selectedSubSectionItemDataAfter !== null;
    }

    function checkCredentialsSubSectionItemUpdate(): boolean {
        const is_subSectionName = checkText(subSectionItemName, true, setSubSectionItemNameError);

        const isAlreadyExistsSectionName = currentSubSection?.sub_section_item_data.some((section) => section.item_name === subSectionItemName && section.item_id !== selectedSubSectionItem?.item_id);
        let isAllowSubSectionName: boolean = true;
        if (isAlreadyExistsSectionName) {
            isAllowSubSectionName = false;
            setSubSectionItemNameError('This sub section item already added');
        }

        return is_subSectionName && isAllowSubSectionName && selectedSubSectionItemDataAfter !== null;
    }

    const handleCloseSubSectionItemModal = () => {
        setShowSubSectionItemModal(false);
        setSubSectionItemNameError('')
        setSubSectionItemNumberAfterError('')
    }

    /* Modal header */
    const subSectionItemModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState} item {dataState === 'Edit' && selectedSubSection?.sub_section_no}
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseSubSectionItemModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const subSectionItemModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Cancel" className="custom_btn secondary" onClick={handleCloseSubSectionItemModal} />

            <Button label={`${loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}`}
                onClick={dataState === 'Add' ? handleCreateSubSectionItem : handleUpdateSubSectionItem}
                loading={loading} className="custom_btn primary" />
        </div>
    );

    const handleSubSectionItemChange = (e: DropdownChangeEvent) => {
        const selectedData = e.value as SowSubSectionItemData;
        setSelectedSubSectionItemDataAfter(selectedData);

        if (selectedData) {
            const subSectionItemNo = selectedData?.after_item_no!;
        } else {
        }
    };

    const subSectionItemOptionsTemplate = (subSectionItem: SubSectionItem) => {
        return (
            <div className="d-flex align-items-center w-100 justify-content-between">
                {subSectionItem.item_no !== '0' ? <div className="data_max_length">{subSectionItem.item_no} - {subSectionItem.item_name}</div> : <div className="data_max_length">{subSectionItem.item_name}</div>}
            </div>
        );
    };

    const subSectionItemValueTemplate = (value: SubSectionItem, props: DropdownProps) => {
        if (value) {
            return (
                <div className="d-flex gap-3 align-items-center">
                    {value?.item_no !== '0' ? <div>{value?.item_no + ' - ' + value?.item_name}</div> : <div>{value?.item_name}</div>}
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };
    /* **************************************************************************** */

    const handleSetPriliminaryAfter = () => {
        if (viewSowPriliminary.length === 0) {
            setSelectedPreliminaryDataAfter(preliminariesList[0])

        } else {
            const largestSection = viewSowPriliminary.reduce((largest, section) => {
                return Number(section.ref_number) > Number(largest.ref_number) ? section : largest;
            }, viewSowPriliminary[0])

            if (largestSection !== null) {
                setSelectedPreliminaryDataAfter(largestSection)
            }
        }



    };

    const handleSetPreliminaryItemNumber = () => {
        if (preliminariesList.length === 0) {
            setPreliminaryItemNumber('1');
        } else {
            if (selectedPreliminaryDataAfter) {
                const lastSectionNo = selectedPreliminaryDataAfter!.after_ref_number! + 1;
                const sectionString = `${lastSectionNo}`;
                setPreliminaryItemNumber(sectionString);
            }

        }
    }

    const handleShowPreliminaries = () => {
        setShowPreliminaries(true);

        setShowSection(false);
        setShowCoverpage(false);
        setShowSubSection(false);
        setShowSubSectionItem(false);

        setToggledSection(false);
        setToggledSubSection(false);

        setSearchKey('');
    }

    const handleAddPreliminary = () => {
        setDataState('Add');
        setShowPreliminaryModal(true);

        setSelectedPreliminary(null);
        setPreliminaryItemName('');

        handleSetPriliminaryAfter();
    }

    const handleEditPreliminary = () => {
        setDataState('Edit');
        setShowPreliminaryModal(true);

        if (selectedPreliminary) {
            setPreliminaryItemName(selectedPreliminary?.item_name!);
            setPreliminaryItemNumber(`${selectedPreliminary?.ref_number}`)

            const afterSection = viewSowPriliminary.filter((section) => section.after_ref_number === selectedPreliminary.after_ref_number)

            if (afterSection !== null) {
                if (afterSection[0].after_ref_number === 0) {
                    setSelectedPreliminaryDataAfter(preliminariesList[0])
                } else {
                    setSelectedPreliminaryDataAfter(preliminariesList[afterSection[0].after_ref_number! - 1])
                }

            }

        } else {
            setPreliminaryItemName('');
            setPreliminaryItemNumber('')
        }
    }

    const handleClosePreliminaryModal = () => {
        setShowPreliminaryModal(false);
        setPreliminaryItemNameError('')
        setPreliminaryItemNumberAfterError('')
    }

    const handleCreatePreliminary = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            if (checkCredentialsPriliminary()) {
                setLoading(true);
                const res = await addSowPriliminary(currentProjectTenderDetail?.project_tender_part_id!, preliminaryItemName, selectedPreliminaryDataAfter?.after_ref_number!)
                setLoading(false);

                if (res.status) {
                    dispatch(getSowPriliminaryData(currentProjectTenderDetail?.project_tender_part_id!))
                    handleClosePreliminaryModal();
                    setHasPreliminary(true);

                    ShowToast(toast, 'success', 'Success', 'Priliminary added successully');

                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error creating preliminary.');
                }
            }


        } catch (error) {
            ShowToast(toast, 'error', 'Failed', 'There was an error creating preliminary.');

        }
    }

    const handleUpdatePreliminary = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            if (checkCredentialsUpdatePriliminary()) {

                setLoading(true);
                const res = await updateSowPriliminary(currentProjectTenderDetail?.project_tender_part_id!, selectedPreliminary?.priliminiery_id!, preliminaryItemName, selectedPreliminaryDataAfter?.after_ref_number!)
                setLoading(false);

                if (res.status) {
                    handleClosePreliminaryModal();
                    setSelectedPreliminary(null);

                    dispatch(getSowPriliminaryData(currentProjectTenderDetail?.project_tender_part_id!))
                    ShowToast(toast, 'success', 'Success', 'Preliminary updated successfully.');


                } else {
                    ShowToast(toast, 'error', 'Failed', 'There was an error updating preliminary.');

                }
            }


        } catch (error) {
            ShowToast(toast, 'error', 'Failed', 'There was an error updating preliminary item.');

        }
    }

    const handleDeletePreliminary = (): void => {
        confirmDialog({
            message: `Are you sure you want to delete the preliminary item (${selectedPreliminary?.ref_number + ". " + selectedPreliminary?.item_name})? `,
            header: 'Confirm the deletion',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deletePreliminary(),
        });
    }

    const deletePreliminary = async () => {
        try {
            const res = await deleteSowPriliminary(selectedPreliminary?.priliminiery_id!)

            if (res.status) {
                setSelectedPreliminary(null);
                dispatch(getSowPriliminaryData(currentProjectTenderDetail?.project_tender_part_id!))
                ShowToast(toast, 'success', 'Success', 'Preliminary deleted successfully.');

            } else {
                ShowToast(toast, 'error', 'Failed', 'Error deleting preliminary.');

            }
        } catch (err) {
            ShowToast(toast, 'error', 'Failed', 'Error deleting preliminary.');

        }
    }

    function checkCredentialsPriliminary(): boolean {
        const is_preliminaryItemName = checkText(preliminaryItemName, true, setPreliminaryItemNameError);

        if (selectedPreliminaryDataAfter === null || selectedPreliminaryDataAfter === undefined) {
            setPreliminaryItemNumberAfterError('This field is required.')
        } else {
            setPreliminaryItemNumberAfterError('')
        }

        const isAlreadyExistsPriliminaryName = viewSowPriliminary?.some((section) => section.item_name === preliminaryItemName);
        let isAllowSubPriliminaryName: boolean = true;
        if (isAlreadyExistsPriliminaryName) {
            isAllowSubPriliminaryName = false;
            setPreliminaryItemNameError('This priliminary already added');
        }

        return is_preliminaryItemName && isAllowSubPriliminaryName && (selectedPreliminaryDataAfter !== null || selectedPreliminaryDataAfter !== undefined);
    }

    function checkCredentialsUpdatePriliminary(): boolean {
        const is_preliminaryItemName = checkText(preliminaryItemName, true, setPreliminaryItemNameError);

        if (selectedPreliminaryDataAfter === null) {
            setPreliminaryItemNumberAfterError('This field is required.')
        } else {
            setPreliminaryItemNumberAfterError('')
        }

        const isAlreadyExistsPriliminaryName = viewSowPriliminary?.some((section) => section.item_name === preliminaryItemName && section.priliminiery_id !== selectedPreliminary?.priliminiery_id);
        let isAllowSubPriliminaryName: boolean = true;
        if (isAlreadyExistsPriliminaryName) {
            isAllowSubPriliminaryName = false;
            setPreliminaryItemNameError('This priliminary already added');
        }

        return is_preliminaryItemName && isAllowSubPriliminaryName && selectedPreliminaryDataAfter !== null;
    }

    /* Modal header */
    const preliminaryModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState} preliminary item {dataState === 'Edit' && selectedSection?.section_no}
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleClosePreliminaryModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const preliminaryModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Cancel" className="custom_btn secondary" onClick={handleClosePreliminaryModal} />
            <Button label={`${loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}`}
                onClick={dataState === 'Add' ? handleCreatePreliminary : handleUpdatePreliminary}
                loading={loading} className="custom_btn primary" />
        </div>
    );

    const handlePreliminaryChange = (e: DropdownChangeEvent) => {
        const selectedData = e.value as Priliminary;
        setSelectedPreliminaryDataAfter(selectedData);

    };

    const preliminaryOptionsTemplate = (item: Priliminary) => {
        return (
            <div className="d-flex align-items-center w-100 justify-content-between">
                {item?.ref_number !== '0' ? <div>{item?.ref_number} - {item?.item_name}</div> : <div>{item?.item_name}</div>}
            </div>
        );
    };

    const preliminaryValueTemplate = (value: Priliminary, props: DropdownProps) => {
        if (value) {
            return (
                <div className="d-flex gap-3 align-items-center">
                    {value.ref_number !== '0' ? <div>{value.ref_number + ' - ' + value?.item_name}</div> : <div>{value?.item_name}</div>}
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };
    /* **************************************************************************** */


    /* **************************** Common functions ***************************** */
    const handleShowSearchModal = () => {
        setShowSearchModal(true);
    }

    const handleShowDownload = () => {
        setShowDownloadModal(true);
    }

    const handleHideDownload = () => {
        setShowDownloadModal(false);
    }

    const formatPrice = (value: number) => {
        return new Intl.NumberFormat('en-UK', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    };

    const getRowClassName = () => {
        return 'project_table_row';
    };

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const goBack = () => {
        navigate(-1);
        goToTop();
    };

    const handleShowSideBar = () => {
        setShowSideBar(!showSideBar);
    }
    /* *************************************************************************** */

    return (
        <div>
            {loadingViewSowSectionAndPriliminary ? (
                <div className="loading_container">
                    <ProgressSpinner className="progresscircle custom" style={{ width: '50px', height: '50px', stroke: '#8953D7' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration="1s" />
                </div>
            ) : (
                <div>
                    <Toast ref={toast} />

                    <div className="project_toolbar">
                        <Button icon={`bi ${showSideBar ? 'bi-arrow-left' : 'bi-list'}`} onClick={handleShowSideBar} className="sidebar_toggle_btn" />
                        <div className="project_tool_options">
                            <div className="project_tool_options_sub">
                                {showCoverPage && (
                                    <React.Fragment>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleAddCoverPage} disabled={tenderPart.have_cover_page_data === true}>
                                            Add
                                            {tenderPart.have_cover_page_data && <Ripple />}
                                        </button>

                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleEditCoverPage} disabled={tenderPart.have_cover_page_data === false}>
                                            Edit
                                            {!tenderPart.have_cover_page_data && <Ripple />}
                                        </button>

                                        {/* <button className={`is_btn project_tool_btn p-ripple`}
                                        onClick={handleDeleteCoverPage} disabled={!tenderPart.have_cover_page_data}>
                                        Delete
                                        {!tenderPart.have_cover_page_data && <Ripple />}
                                    </button> */}
                                    </React.Fragment>
                                )}

                                {showSection && (
                                    <React.Fragment>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleAddSection}>
                                            Add
                                            <Ripple />
                                        </button>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleEditSection} disabled={!hasSection || selectedSection === null}>
                                            Edit
                                            {hasSection && selectedSection !== null && <Ripple />}
                                        </button>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleDeleteSection} disabled={!hasSection || selectedSection === null}>
                                            Delete
                                            {hasSection && selectedSection !== null && <Ripple />}
                                        </button>
                                    </React.Fragment>
                                )}

                                {showSubSection && (
                                    <React.Fragment>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleAddSubSection}>
                                            Add
                                            <Ripple />
                                        </button>

                                        {hasSubSection && (
                                            <React.Fragment>
                                                <button className={`is_btn project_tool_btn p-ripple`}
                                                    onClick={handleEditSubSection} disabled={!hasSubSection || selectedSubSection === null}>
                                                    Edit
                                                    {hasSubSection && selectedSubSection !== null && <Ripple />}
                                                </button>
                                                <button className={`is_btn project_tool_btn p-ripple`}
                                                    onClick={handleDeleteSubSection} disabled={!hasSubSection || selectedSubSection === null}>
                                                    Delete
                                                    {hasSubSection && selectedSubSection !== null && <Ripple />}
                                                </button>
                                            </React.Fragment>
                                        )}

                                        {hasSectionItem && (
                                            <React.Fragment>
                                                <button className={`is_btn project_tool_btn p-ripple`}
                                                    onClick={handleEditItem} disabled={!hasSectionItem || selectedSectionItem === null}>
                                                    Edit
                                                    {hasSectionItem && selectedSectionItem !== null && <Ripple />}
                                                </button>
                                                <button className={`is_btn project_tool_btn p-ripple`}
                                                    onClick={handleDeleteItem} disabled={!hasSectionItem || selectedSectionItem === null}>
                                                    Delete
                                                    {hasSectionItem && selectedSectionItem !== null && <Ripple />}
                                                </button>
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                )}

                                {showSubSectionItem && (
                                    <React.Fragment>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleAddSubSectionItem}>
                                            Add
                                            <Ripple />
                                        </button>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleEditSubSectionItem} disabled={!showSubSectionItem || selectedSubSectionItem === null}>
                                            Edit
                                            {showSubSectionItem && selectedSubSectionItem !== null && <Ripple />}
                                        </button>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleDeleteSubSectionItem} disabled={!showSubSectionItem || selectedSubSectionItem === null}>
                                            Delete
                                            {showSubSectionItem && selectedSubSectionItem !== null && <Ripple />}
                                        </button>
                                    </React.Fragment>
                                )}

                                {showPreliminaries && (
                                    <React.Fragment>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleAddPreliminary}>
                                            Add
                                            <Ripple />
                                        </button>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleEditPreliminary} disabled={!showPreliminaries || selectedPreliminary === null}>
                                            Edit
                                            <Ripple />
                                        </button>
                                        <button className={`is_btn project_tool_btn p-ripple`}
                                            onClick={handleDeletePreliminary} disabled={!showPreliminaries || selectedPreliminary === null}>
                                            Delete
                                            <Ripple />
                                        </button>
                                    </React.Fragment>
                                )}

                                {/* <button className={`is_btn project_tool_btn p-ripple`}
                                onClick={() => navigate('/project/detail/default-service/pre-commencement/tender/sow/customize/view', {state: tenderPart})}>
                                View
                                <Ripple />
                            </button> */}
                            </div>

                            <div className="project_tool_options_sub">
                                {((showPreliminaries === true && hasPreliminary === true) || (showSubSection === true && hasSectionItem === true) || (showSubSectionItem === true && hasSubSectionItem === true)) && (
                                    <button className={`is_btn project_tool_btn p-ripple`}
                                        onClick={handleShowSearchModal}>
                                        Search
                                        <Ripple />
                                    </button>
                                )}
                                {/* <button className={`is_btn project_tool_btn p-ripple`}
                                onClick={handleShowDownload}>
                                Download
                                <Ripple />
                            </button> */}
                                <button className={`is_btn project_tool_btn p-ripple`}
                                    onClick={goBack}>
                                    Back
                                    <Ripple />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className={`project_sidebar ${showSideBar ? 'show' : ''}`}>
                        <ul className="section_list">
                            {/* Cover page */}
                            <li className="section_list_item">
                                <div className={`section_link_grp ${showCoverPage && 'active'}`}>
                                    <i className="bi bi-caret-right-fill section_link_icon"></i>
                                    <button className="section_link is_btn"
                                        onClick={handleShowCoverPage}>
                                        <span>Cover page</span>
                                    </button>
                                </div>
                            </li>

                            {/* Sections */}

                            {loadingViewSowSection ? (
                                <div className="loading_container">
                                    <ProgressSpinner className="progresscircle custom" style={{ width: '50px', height: '50px', stroke: '#8953D7' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration="1s" />
                                </div>
                            ) : (
                                <li className="section_list_item">
                                    <div className={`section_link_grp ${showSection && 'active'} ${toggledSection && viewSowSection?.length > 0 && 'has_child'} `}>
                                        <i className="bi bi-caret-right-fill section_link_icon"></i>
                                        <button className="section_link is_btn"
                                            onClick={handleShowSections}>
                                            <span>Contents</span>
                                        </button>
                                    </div>

                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{
                                            height: toggledSection ? 'auto' : 0,
                                            opacity: toggledSection ? 1 : 0,
                                        }}
                                        transition={{ duration: 0.5, ease: 'easeInOut' }}
                                        style={{ overflow: 'hidden' }}
                                    >
                                        {viewSowSection?.length > 0 && (
                                            <ul className="section_sub_list">
                                                {viewSowSection?.map((section) => (
                                                    <li key={section.section_id} className="section_sub_list_item">
                                                        <div className={`section_link_grp ${showSubSection && section.section_id === currentSection?.section_id && 'active'} ${toggledSubSection && section?.sub_section_data?.length! > 0 && 'has_child'} `}>
                                                            <i className="bi bi-caret-right section_link_icon"></i>
                                                            <button className="section_link is_btn"
                                                                onClick={() => handleShowSubSection(section)}>
                                                                <span>{section.section_name}</span>
                                                            </button>
                                                        </div>

                                                        <motion.div
                                                            initial={{ height: 0, opacity: 0 }}
                                                            animate={{
                                                                height: toggledSubSection ? 'auto' : 0,
                                                                opacity: toggledSubSection ? 1 : 0,
                                                            }}
                                                            transition={{ duration: 0.5, ease: 'easeInOut' }}
                                                            style={{ overflow: 'hidden' }}
                                                        >
                                                            {section?.sub_section_data?.length! > 0 && (
                                                                <ul className="section_sub_list_sub">
                                                                    {section.sub_section_data?.map((sub_section) => (
                                                                        <li className="section_sub_list_item_sub" key={sub_section.sub_section_id}>
                                                                            <div className={`section_link_grp ${showSubSectionItem && sub_section.sub_section_id === currentSubSection?.sub_section_id && 'active'} `}>
                                                                                <small>{sub_section.sub_section_no}</small>
                                                                                <button className="section_link is_btn"
                                                                                    onClick={() => handleShowSubSectionItem(sub_section)}>
                                                                                    <span>{sub_section.sub_section_name}</span>
                                                                                </button>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </motion.div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </motion.div>
                                </li>
                            )}

                            {/* Preliminaries */}
                            {loadingViewSowPriliminary ? (
                                <div className="loading_container">
                                    <ProgressSpinner className="progresscircle custom" style={{ width: '50px', height: '50px', stroke: '#8953D7' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration="1s" />
                                </div>
                            ) : (
                                <li className="section_list_item">
                                    <div className={`section_link_grp ${showPreliminaries && 'active'} `}>
                                        <i className="bi bi-caret-right-fill section_link_icon"></i>
                                        <button className="section_link is_btn"
                                            onClick={handleShowPreliminaries}>
                                            <span>Preliminaries</span>
                                        </button>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>

                    <div className={`layout_backdrop ${showSideBar ? 'show' : ''}`} onClick={handleShowSideBar}></div>

                    <div className={`project_main_content ${showSideBar ? 'has_sidebar' : ''}`}>
                        {showCoverPage && (
                            <article className="main_section_area d-flex">
                                {currentProjectTenderDetail ? (
                                    <div className="cover_page_area">
                                        <h2>Schedule of work</h2>
                                        <h6>
                                            {currentProjectTenderDetail.coverPageDesc}
                                        </h6>
                                        <h5>At</h5>
                                        <h5>{currentProjectTenderDetail.project_address}</h5>
                                        <br />
                                        {currentProjectTenderDetail.company_name ? (<h5>For <br />{currentProjectTenderDetail.company_name!}</h5>) : null}
                                    </div>
                                ) : (
                                    <div className="no_content_added_area">
                                        <img src="/assets/images/no_data/no_data_img.png" alt="No data!" />
                                        <p>Note : No cover page added, to add the cover page click on add button</p>
                                    </div>
                                )}
                            </article>
                        )}

                        {loadingViewSowSection ? (
                            <div className="loading_container">
                                <ProgressSpinner className="progresscircle custom" style={{ width: '50px', height: '50px', stroke: '#8953D7' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration="1s" />
                            </div>
                        ) : showSection && (
                            <article className="main_section_area">
                                {viewSowSection?.length ? (
                                    <React.Fragment>
                                        {viewSowSection?.length > 0 && (
                                            <DataTable
                                                value={viewSowSection}
                                                size="small"
                                                tableStyle={{ minWidth: '50rem' }}
                                                className="page_table project_table p-0 p-sm-2"
                                                rowHover
                                                tableClassName="mb-1"
                                                rowClassName={getRowClassName}
                                                selectionMode="single" selection={selectedSection!}
                                                onSelectionChange={(e) => setSelectedSection(e.value)}
                                                dataKey="section_id"
                                                scrollable
                                                scrollHeight={'75vh'}
                                                emptyMessage="No data found"
                                            >
                                                <Column
                                                    header="Section no."
                                                    alignHeader={'center'}
                                                    body={(rowData) => rowData.section_no ? <span className="flex_center">{rowData.section_no}</span> : '--'}
                                                    style={{ width: '15%' }}
                                                    className="table_column"
                                                ></Column>
                                                <Column
                                                    header="Content"
                                                    body={(rowData) => rowData.section_name ? <span>{rowData.section_name}</span> : '--'}
                                                    style={{ width: '65%' }}
                                                    className="table_column"
                                                ></Column>
                                                <Column
                                                    header="Price"
                                                    alignHeader={'right'}
                                                    body={(rowData) => rowData.section_amount !== null ?
                                                        <span className="flex-end text-end text_no_wrap">
                                                            {currencySymbol}&nbsp;{formatPrice(rowData.section_amount)}
                                                        </span> : '--'}
                                                    style={{ width: '20%' }}
                                                    className="table_column text-end"
                                                ></Column>
                                            </DataTable>
                                        )}
                                    </React.Fragment>
                                ) : (
                                    <div className="no_content_added_area">
                                        <img src="/assets/images/no_data/no_data_img.png" alt="No data!" />
                                        <p>Note : no section added, to add the new section click on add button</p>
                                    </div>
                                )}
                            </article>
                        )}

                        {showSubSection && (
                            <article className="main_section_area">
                                {currentSection && (
                                    <div className="main_section_header">
                                        <h6>{currentSection?.section_no}.&nbsp;&nbsp;{currentSection?.section_name}</h6>
                                    </div>
                                )}

                                {hasSubSection && (
                                    <React.Fragment>
                                        {currentSection?.sub_section_data && (
                                            <DataTable
                                                value={currentSection?.sub_section_data}
                                                size="small"
                                                tableStyle={{ minWidth: '50rem' }}
                                                className="page_table project_table p-0 p-sm-2"
                                                rowHover
                                                tableClassName="mb-1"
                                                rowClassName={getRowClassName}
                                                selectionMode="single"
                                                selection={selectedSubSection!}
                                                onSelectionChange={(e) => setSelectedSubSection(e.value)}
                                                dataKey="sub_section_id"
                                                scrollable
                                                scrollHeight={'75vh'}
                                                emptyMessage="No data found"
                                            >
                                                <Column
                                                    header="Sub section no."
                                                    alignHeader={'center'}
                                                    body={(rowData) => rowData.sub_section_no ? <span className="flex_center">{rowData.sub_section_no}</span> : '--'}
                                                    style={{ width: '15%' }}
                                                    className="table_column"
                                                ></Column>

                                                <Column
                                                    header="Sub section name"
                                                    body={(rowData) => rowData.sub_section_name ? <span>{rowData.sub_section_name}</span> : '--'}
                                                    style={{ width: '65%' }}
                                                    className="table_column"
                                                ></Column>

                                                <Column
                                                    header="Price"
                                                    alignHeader={'right'}
                                                    body={(rowData) => rowData.sub_section_amount !== null ?
                                                        <span className="flex-end text-end text_no_wrap">
                                                            {currencySymbol}&nbsp;{formatPrice(rowData.sub_section_amount)}
                                                        </span> : '--'}
                                                    style={{ width: '20%' }}
                                                    className="table_column text-end"
                                                ></Column>
                                            </DataTable>
                                        )}
                                    </React.Fragment>
                                )}

                                {hasSectionItem && (
                                    <React.Fragment>
                                        {currentSection?.section_item_data && (
                                            <DataTable
                                                value={filteredSectionItemData}
                                                size="small"
                                                tableStyle={{ minWidth: '50rem' }}
                                                className="page_table project_table p-0 p-sm-2"
                                                rowHover
                                                tableClassName="mb-1"
                                                rowClassName={getRowClassName}
                                                selectionMode="single"
                                                selection={selectedSectionItem!}
                                                onSelectionChange={(e) => setSelectedSectionItem(e.value)}
                                                dataKey="item_id"
                                                scrollable
                                                scrollHeight={'75vh'}
                                                emptyMessage="No data found"
                                            >
                                                <Column
                                                    header="Item no."
                                                    alignHeader={'center'}
                                                    body={(rowData) => rowData.item_no ? <span className="flex_center">{rowData.item_no}</span> : '--'}
                                                    style={{ width: '8%' }}
                                                    className="table_column"
                                                ></Column>

                                                <Column
                                                    header="Item name"
                                                    body={(rowData) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                                    style={{ width: '30%' }}
                                                    className="table_column"
                                                ></Column>

                                                <Column
                                                    header="Unit no."
                                                    alignHeader={'center'}
                                                    style={{ width: '10%' }}
                                                    className="table_column column_editable"
                                                ></Column>

                                                <Column
                                                    header="Unit price"
                                                    alignHeader={'right'}
                                                    style={{ width: '12%' }}
                                                    className="table_column text-end column_editable"
                                                ></Column>

                                                <Column
                                                    header="Sub total"
                                                    alignHeader={'right'}
                                                    style={{ width: '12%' }}
                                                    className="table_column text-end"
                                                ></Column>

                                                <Column
                                                    header="Note"
                                                    alignHeader={'center'}
                                                    style={{ width: '28%' }}
                                                    className="table_column"
                                                ></Column>
                                            </DataTable>
                                        )}
                                    </React.Fragment>
                                )}

                                {!hasSubSection && !hasSectionItem && (
                                    <div className="no_content_added_area">
                                        <img src="/assets/images/no_data/no_data_img.png" alt="No data!" />
                                        <p>Note: to add the data click add button</p>
                                    </div>
                                )}
                            </article>
                        )}

                        {showSubSectionItem && (
                            <article className="main_section_area">
                                {currentSubSection && (
                                    <div className="main_section_header">
                                        <h6>{currentSubSection?.sub_section_no}.&nbsp;&nbsp;{currentSubSection?.sub_section_name}</h6>
                                    </div>
                                )}

                                {hasSubSectionItem ? (
                                    <React.Fragment>
                                        {currentSubSection?.sub_section_item_data && (
                                            <DataTable
                                                value={filteredSubSectionItemData}
                                                size="small"
                                                tableStyle={{ minWidth: '50rem' }}
                                                className="page_table project_table p-0 p-sm-2"
                                                rowHover
                                                tableClassName="mb-1"
                                                rowClassName={getRowClassName}
                                                selectionMode="single"
                                                selection={selectedSubSectionItem!}
                                                onSelectionChange={(e) => setSelectedSubSectionItem(e.value)}
                                                dataKey="item_id"
                                                scrollable
                                                scrollHeight={'75vh'}
                                                emptyMessage="No data found"
                                            >
                                                <Column
                                                    header="Item no."
                                                    alignHeader={'center'}
                                                    body={(rowData) => rowData.item_no ? <span className="flex_center">{rowData.item_no}</span> : '--'}
                                                    style={{ width: '8%' }}
                                                    className="table_column"
                                                ></Column>

                                                <Column
                                                    header="Item name"
                                                    body={(rowData) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                                    style={{ width: '30%' }}
                                                    className="table_column"
                                                ></Column>

                                                <Column
                                                    header="Unit no."
                                                    alignHeader={'center'}
                                                    style={{ width: '10%' }}
                                                    className="table_column column_editable"
                                                ></Column>

                                                <Column
                                                    header="Unit price"
                                                    alignHeader={'right'}
                                                    style={{ width: '12%' }}
                                                    className="table_column text-end column_editable"
                                                ></Column>

                                                <Column
                                                    header="Sub total"
                                                    alignHeader={'right'}
                                                    style={{ width: '12%' }}
                                                    className="table_column text-end"
                                                ></Column>

                                                <Column
                                                    header="Note"
                                                    alignHeader={'center'}
                                                    style={{ width: '28%' }}
                                                    className="table_column"
                                                ></Column>
                                            </DataTable>
                                        )}
                                    </React.Fragment>
                                ) : (
                                    <div className="no_content_added_area">
                                        <img src="/assets/images/no_data/no_data_img.png" alt="No data!" />
                                        <p>Note: to add the item click add button</p>
                                    </div>
                                )}
                            </article>
                        )}

                        {loadingViewSowPriliminary ? (
                            <div className="loading_container">
                                <ProgressSpinner className="progresscircle custom" style={{ width: '50px', height: '50px', stroke: '#8953D7' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration="1s" />
                            </div>
                        ) : showPreliminaries && (
                            <article className="main_section_area">
                                {viewSowPriliminary?.length > 0 ? (
                                    <React.Fragment>
                                        {viewSowPriliminary?.length > 0 && (
                                            <DataTable
                                                value={viewSowPriliminary}
                                                size="small"
                                                tableStyle={{ minWidth: '50rem' }}
                                                className="page_table project_table p-0 p-sm-2"
                                                rowHover
                                                tableClassName="mb-1"
                                                rowClassName={getRowClassName}
                                                selectionMode="single"
                                                selection={selectedPreliminary!}
                                                onSelectionChange={(e) => setSelectedPreliminary(e.value)}
                                                dataKey="priliminiery_id"
                                                scrollable
                                                scrollHeight={'75vh'}
                                                emptyMessage="No data found"
                                            >
                                                <Column
                                                    header="Item no."
                                                    alignHeader={'center'}
                                                    body={(rowData) => rowData.ref_number ? <span className="flex_center">{rowData.ref_number}</span> : '--'}
                                                    style={{ width: '8%' }}
                                                    className="table_column"
                                                ></Column>

                                                <Column
                                                    header="Item name"
                                                    body={(rowData) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                                    style={{ width: '30%' }}
                                                    className="table_column"
                                                ></Column>

                                                <Column
                                                    header="Unit no."
                                                    alignHeader={'center'}
                                                    style={{ width: '10%' }}
                                                    className="table_column text-center column_editable"
                                                ></Column>

                                                <Column
                                                    header="Unit price"
                                                    alignHeader={'right'}
                                                    style={{ width: '12%' }}
                                                    className="table_column column_editable text-end"
                                                ></Column>

                                                <Column
                                                    header="Sub total"
                                                    alignHeader={'right'}
                                                    style={{ width: '12%' }}
                                                    className="table_column text-end"
                                                ></Column>

                                                <Column
                                                    header="Note"
                                                    alignHeader={'center'}
                                                    style={{ width: '28%' }}
                                                    className="table_column"
                                                ></Column>
                                            </DataTable>
                                        )}
                                    </React.Fragment>
                                ) : (
                                    <div className="no_content_added_area">
                                        <img src="/assets/images/no_data/no_data_img.png" alt="No data!" />
                                        <p>Note : to add preliminary click on add button</p>
                                    </div>
                                )}
                            </article>
                        )}
                    </div>


                    {/* Cover page modal */}
                    <Dialog header={coverPageModalHeader} footer={coverPageModalFooter} dismissableMask headerClassName="custom_modal_header"
                        visible={showCoverPageModal} className="custom_modal_dialog modal_dialog_md"
                        onHide={() => { if (!showCoverPageModal) return; setShowCoverPageModal(false); }}>
                        <div className="custom_modal_body">
                            <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                                <div className="row">
                                    {/* Body */}
                                    <div className="col-12">
                                        <Textarea
                                            id="coverPageBody"
                                            label="Cover page content"
                                            labelHtmlFor="coverPageBody"
                                            required={true}
                                            value={coverPageBody}
                                            placeholder="Type here"
                                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setCoverPageBody(e.target.value)}
                                            error={coverPageBodyError}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className={`custom_form_label mb - 1`}>The cover page will look like this.</label>
                                        <div className="cover_page_body">
                                            <div className="cover_page_area">
                                                <h2>Schedule of work</h2>
                                                <h6>
                                                    {coverPageBody ? coverPageBody : '----------------------------------------------------------------'}
                                                </h6>
                                                <h5>At</h5>
                                                <h5>258-260 LONDON ROAD <br />Croydon CRO 2TH</h5>
                                                <br />
                                                <h5>For <br />ABC LTD</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>


                    {/* Section modal */}
                    <Dialog header={sectionModalHeader} footer={sectionModalFooter} dismissableMask headerClassName="custom_modal_header"
                        visible={showSectionModal} className="custom_modal_dialog modal_dialog_md"
                        onHide={() => { if (!showSectionModal) return; setShowSectionModal(false); }}>
                        <div className="custom_modal_body">
                            <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                                <div className="row">
                                    {/*  Section number */}
                                    <div className="col-12 col-sm-4">
                                        <div className="page_form_group">
                                            <label htmlFor="sectionNumber" className="custom_form_label">Section no. <small>{dataState === 'Add' ? "(Auto generated)" : "(Can't modify)"}</small></label>
                                            <InputText id="sectionNumber" disabled value={sectionNumber} />
                                        </div>
                                    </div>

                                    {/* Content name */}
                                    <div className="col-12 col-sm-8">
                                        <TextInput
                                            id="sectionName"
                                            label="Section name"
                                            labelHtmlFor="sectionName"
                                            required={true}
                                            value={sectionName}
                                            placeholder="Section name"
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSectionName(e.target.value)}
                                            error={sectionNameError}
                                        />
                                    </div>

                                    {/* Section number after */}
                                    <div className="col-12 col-sm-6">
                                        <div className="page_form_group mb-0">
                                            <label htmlFor="selectedSectionData" className="custom_form_label is_required">Section no. after</label>
                                            <Dropdown
                                                id="selectedSectionData"
                                                value={selectedSectionDataAfter}
                                                onChange={handleSectionChange}
                                                options={sectionsList}
                                                valueTemplate={sectionValueTemplate}
                                                itemTemplate={sectionOptionsTemplate}
                                                optionLabel="section_no"
                                                placeholder="Select section"
                                                className="form_dropdown w-100"
                                                filter
                                                filterBy="section_no"
                                                filterPlaceholder="Search by section number"
                                            />

                                            {sectionNoAfterError && <small className="form_error_msg">{sectionNoAfterError}</small>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>


                    {/* Sub section modal */}
                    <Dialog header={subSectionModalHeader} footer={subSectionModalFooter} dismissableMask headerClassName="custom_modal_header"
                        visible={showSubSectionModal} className="custom_modal_dialog modal_dialog_md"
                        onHide={() => { if (!showSubSectionModal) return; setShowSubSectionModal(false); }}>
                        <div className="custom_modal_body">
                            <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                                {dataState === 'Add' && currentSection?.sub_section_data?.length === 0 && currentSection?.section_item_data?.length === 0 && (
                                    <div className="row radio_grp_container">
                                        <div className="col-12">
                                            <div className="page_radio_option_group">
                                                <div className="page_radio_option_item">
                                                    <RadioButton inputId="addSubSection" name="addState" value="sub section"
                                                        onChange={(e: RadioButtonChangeEvent) => setAddState(e.value)}
                                                        checked={addState === 'sub section'} />
                                                    <label htmlFor="addSubSection">Add sub section</label>
                                                </div>

                                                <div className="page_radio_option_item">
                                                    <RadioButton inputId="addItem" name="addState" value="item"
                                                        onChange={(e: RadioButtonChangeEvent) => setAddState(e.value)}
                                                        checked={addState === 'item'} />
                                                    <label htmlFor="addItem">Add item</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {addState === 'sub section' ? (
                                    <div className="row">
                                        {/*  Sub section number */}
                                        <div className="col-12 col-sm-5">
                                            <div className="page_form_group">
                                                <label htmlFor="subSectionNumber" className="custom_form_label">Sub section no. <small>{dataState === 'Add' ? "(Auto generated)" : "(Can't modify)"}</small></label>
                                                <InputText id="subSectionNumber" disabled value={subSectionNumber} />
                                            </div>
                                        </div>

                                        {/* Subsection name */}
                                        <div className="col-12 col-sm-7">
                                            <TextInput
                                                id="subSectionName"
                                                label="Sub section name"
                                                labelHtmlFor="subSectionName"
                                                required={true}
                                                value={subSectionName}
                                                placeholder="Sub section name"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSubSectionName(e.target.value)}
                                                error={subSectionNameError}
                                            />
                                        </div>

                                        {/* Sub section number after */}
                                        <div className="col-12 col-sm-6">
                                            <div className="page_form_group mb-0">
                                                <label htmlFor="selectedSubSectionData" className="custom_form_label is_required">Section no. after</label>
                                                <Dropdown
                                                    id="selectedSubSectionData"
                                                    value={selectedSubSectionDataAfter}
                                                    onChange={handleSubSectionChange}
                                                    options={subSectionsList}
                                                    optionLabel="sub_section_no"
                                                    itemTemplate={subSectionOptionsTemplate}
                                                    valueTemplate={subSectionValueTemplate}
                                                    placeholder="Select sub section"
                                                    className="form_dropdown w-100"
                                                    filter
                                                    filterBy="sub_section_no"
                                                    filterPlaceholder="Search by sub section number"
                                                />
                                                {subSectionNoAfterError && <small className="form_error_msg">{subSectionNoAfterError}</small>}
                                            </div>
                                        </div>
                                    </div>
                                ) : addState === 'item' ? (
                                    <div className="row">
                                        {/*  Section item number */}
                                        <div className="col-12 col-sm-5">
                                            <div className="page_form_group">
                                                <label htmlFor="sectionItemNumber" className="custom_form_label">Item no. <small>{dataState === 'Add' ? "(Auto generated)" : "(Can't modify)"}</small></label>
                                                <InputText id="sectionItemNumber" disabled value={sectionItemNumber} />
                                            </div>
                                        </div>

                                        {/* Section item name */}
                                        <div className="col-12 col-sm-7">
                                            <TextInput
                                                id="itemName"
                                                label="Item name"
                                                labelHtmlFor="itemName"
                                                required={true}
                                                value={sectionItemName}
                                                placeholder="Item name"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSectionItemName(e.target.value)}
                                                error={sectionItemNameError}
                                            />
                                        </div>

                                        {/* Section item number after */}
                                        <div className="col-12 col-sm-6">
                                            <div className="page_form_group mb-0">
                                                <label htmlFor="selectedItemData" className="custom_form_label is_required">Item no. after</label>
                                                <Dropdown
                                                    id="selectedItemData"
                                                    value={selectedSectionItemDataAfter}
                                                    onChange={handleSectionItemChange}
                                                    options={sectionItemsList}
                                                    optionLabel="item_no"
                                                    itemTemplate={sectionItemOptionsTemplate}
                                                    valueTemplate={sectionItemValueTemplate}
                                                    placeholder="Select item"
                                                    className="form_dropdown w-100"
                                                    filter
                                                    filterBy="item_no"
                                                    filterPlaceholder="Search by item number"
                                                />

                                                {sectionItemNumberAfterError && <small className="form_error_msg">{sectionItemNumberAfterError}</small>}
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Dialog>


                    {/* Sub section item modal */}
                    <Dialog header={subSectionItemModalHeader} footer={subSectionItemModalFooter} dismissableMask headerClassName="custom_modal_header"
                        visible={showSubSectionItemModal} className="custom_modal_dialog modal_dialog_md"
                        onHide={() => { if (!showSubSectionItemModal) return; setShowSubSectionItemModal(false); }}>
                        <div className="custom_modal_body">
                            <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                                <div className="row">
                                    {/*  Sub section item number */}
                                    <div className="col-12 col-sm-5">
                                        <div className="page_form_group">
                                            <label htmlFor="subSectionItemNumber" className="custom_form_label">Item no. <small>{dataState === 'Add' ? "(Auto generated)" : "(Can't modify)"}</small></label>
                                            <InputText id="subSectionItemNumber" disabled value={subSectionItemNumber} />
                                        </div>
                                    </div>

                                    {/* Item name */}
                                    <div className="col-12 col-sm-7">
                                        <TextInput
                                            id="subSectionItemName"
                                            label="Item name"
                                            labelHtmlFor="subSectionItemName"
                                            required={true}
                                            value={subSectionItemName}
                                            placeholder="Item name"
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSubSectionItemName(e.target.value)}
                                            error={subSectionItemNameError}
                                        />
                                    </div>

                                    {/* Item number after */}
                                    <div className="col-12 col-sm-6">
                                        <div className="page_form_group mb-0">
                                            <label htmlFor="selectedSubSectionItemData" className="custom_form_label is_required">Item no. after</label>
                                            <Dropdown
                                                id="selectedSubSectionItemData"
                                                value={selectedSubSectionItemDataAfter}
                                                onChange={handleSubSectionItemChange}
                                                options={subSectionItemsList}
                                                optionLabel="item_no"
                                                itemTemplate={subSectionItemOptionsTemplate}
                                                valueTemplate={subSectionItemValueTemplate}
                                                placeholder="Select item"
                                                className="form_dropdown w-100"
                                                filter
                                                filterBy="item_no"
                                                filterPlaceholder="Search by item number"
                                            />

                                            {subSectionItemNumberAfterError && <small className="form_error_msg">{subSectionItemNumberAfterError}</small>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>


                    {/* Preliminary modal */}
                    <Dialog header={preliminaryModalHeader} footer={preliminaryModalFooter} dismissableMask headerClassName="custom_modal_header"
                        visible={showPreliminaryModal} className="custom_modal_dialog modal_dialog_md"
                        onHide={() => { if (!showPreliminaryModal) return; setShowPreliminaryModal(false); }}>
                        <div className="custom_modal_body">
                            <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                                <div className="row">
                                    {/* Item number */}
                                    <div className="col-12 col-sm-4">
                                        <div className="page_form_group">
                                            <label htmlFor="" className="custom_form_label">Item no. <small>{dataState === 'Add' ? "(Auto generated)" : "(Can't modify)"}</small></label>
                                            <InputText disabled value={preliminaryItemNumber} />
                                        </div>
                                    </div>

                                    {/* Item name */}
                                    <div className="col-12 col-sm-8">
                                        <TextInput
                                            id="preliminaryItemName"
                                            label="Item name"
                                            labelHtmlFor="preliminaryItemName"
                                            required={true}
                                            value={preliminaryItemName}
                                            placeholder="Item name"
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPreliminaryItemName(e.target.value)}
                                            error={preliminaryItemNameError}
                                        />
                                    </div>

                                    {/* Item number after  */}
                                    <div className="col-12 col-sm-6">
                                        <div className="page_form_group mb-0">
                                            <label htmlFor="selectedPreliminaryData" className="custom_form_label is_required">Item number after</label>
                                            <Dropdown
                                                id="selectedPreliminaryData"
                                                value={selectedPreliminaryDataAfter}
                                                onChange={handlePreliminaryChange}
                                                options={preliminariesList}
                                                optionLabel="ref_number"
                                                valueTemplate={preliminaryValueTemplate}
                                                itemTemplate={preliminaryOptionsTemplate}
                                                placeholder="Select item"
                                                className="form_dropdown w-100"
                                                filter
                                                filterBy="ref_number"
                                                filterPlaceholder="Search by item number"
                                            />

                                            {preliminaryItemNumberAfterError && <small className="form_error_msg">{preliminaryItemNumberAfterError}</small>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>


                    {/* Search modal */}
                    <Dialog headerClassName="custom_modal_header search_modal_header" position="top"
                        headerStyle={{ display: 'none' }} dismissableMask
                        visible={showSearchModal} className="custom_modal_dialog modal_dialog_sm"
                        onHide={() => { if (!showSearchModal) return; setShowSearchModal(false); }}>
                        <div className="custom_modal_body">
                            <button className="custom_modal_close float p-ripple"
                                onClick={() => setShowSearchModal(false)}>
                                <i className="bi bi-x-lg"></i>
                                <Ripple />
                            </button>

                            <div className="row">
                                <div className="col-12">
                                    <IconField iconPosition="left">
                                        <InputIcon className="bi bi-search"> </InputIcon>
                                        <InputText
                                            id="searchKey"
                                            name="searchKey"
                                            placeholder="Search by item name and number"
                                            value={searchKey}
                                            autoFocus
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchKey(e.target.value)}
                                        />
                                    </IconField>
                                </div>
                            </div>
                        </div>
                    </Dialog>


                    {/* Download modal */}
                    <DownloadSOW
                        isOpen={showDownloadModal}
                        onClose={handleHideDownload}
                        coverPageDesc={tenderPart.coverPageDesc}
                        projectTenderDetailInterface={tenderPart}
                        sowSection={viewSowSection}
                        sowPriliminary={viewSowPriliminary}
                    />

                    {/* Show success message */}
                    <div className={`message_backdrop ${showAlert ? 'show' : ''}`} onClick={handleCloseAlert}>
                        <div className={`message_box ${showAlert ? 'show' : ''}`} onClick={e => e.stopPropagation()}>
                            <div className="message_box_content">
                                <i className="bi bi-check-circle-fill message_box_icon"></i>
                                <h6 className="message_box_message">
                                    {successMessage}
                                </h6>
                            </div>
                        </div>
                    </div>
                    {/*  */}
                </div >
            )}
        </div>
    )
}

export default CustomSOW;